import { Routes } from '@angular/router';
import { Login } from './login/login';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuard } from './auth/auth.guard';
import { LicenseTerms } from './license-terms/license-terms';

export const appRoutes: Routes = [
    {
        path: 'ops',
        loadChildren: () =>
            import('./operations/operations-routes').then(m => m.operationRoutes),
    },
    {
        path: 'ops/vendors',
        loadChildren: () =>
            import('./operations/ops-vendors/ops-vendors-routes').then(m => m.vendorRoutes),
    },
    {
        path: 'ops/maintenance',
        loadChildren: () =>
            import('./operations/ops-maintenance/ops-maintenance-routes').then(m => m.maintenanceRoutes),
    },
    {
         path: '', component: Login ,
    },
    {
         path: 'login', component: Login ,
    },
    {
         path: 'license-terms', component: LicenseTerms ,
    },
    {
         path: 'dashboard', 
         component: DashboardComponent,
         canActivate: [AuthGuard]
    },
    {
        path: 'pos',
        loadChildren: () =>
            import('./point-of-sales/point-of-sales.routes').then(m => m.posRoutes),
    },
    {
        path: 'ops/pos',
        loadChildren: () =>
            import('./operations/ops-point-of-sales/ops-point-of-sales-routes').then(m => m.PointOfSalesRoutes),
    },
    {
        path: 'ops/report',
        loadChildren: () =>
            import('./operations/ops-report/ops-reports-routes').then(m => m.ReportsRoutes),
    },
    {
        path: 'ops/inventory',
        loadChildren: () =>
            import('./operations/ops-inventory/ops-inventory.routes').then(m => m.inventoryRoutes),
    },
    {
        path: 'ops/qb',
        loadChildren: () =>
            import('./operations/ops-qb-interface/ops-qb-interface-routes').then(m => m.qbInterfaceRoutes),
    }
];
